/* Cart drawer — Sidecar flyout.
   Opens on header cart-icon click (.js-cart-open) and on any add-to-cart.
   State comes from the `cart-drawer` section via the Section Rendering API,
   so the whole drawer re-renders server-side on every change. */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.querySelector('.js-cart-overlay');
    var drawer = document.querySelector('.js-cart-drawer');
    if (!drawer || !overlay) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    var cartChangeUrl = root + 'cart/change.js';
    var cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : root + 'cart/add.js';
    var cartUpdating = false;

    /* ---- Open / close ------------------------------------------------ */
    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (window.dlEcommerce) window.dlEcommerce.viewCart();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('.js-cart-open');
      if (opener) {
        e.preventDefault();
        openDrawer();
      }
    });

    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    /* ---- Shipping bar animation ------------------------------------- */
    function getShippingBarWidth() {
      var fill = drawer.querySelector('.cart-drawer_shipping-fill');
      if (!fill || fill.dataset.width == null) return null;
      return parseInt(fill.dataset.width, 10);
    }

    function animateShippingBars(fromWidth) {
      var start = fromWidth != null ? fromWidth : 0;
      drawer.querySelectorAll('.cart-drawer_shipping-fill').forEach(function (fill) {
        var target = fill.dataset.width;
        if (target == null || target === '') return;
        target = parseInt(target, 10);
        fill.style.width = start + '%';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            fill.style.width = target + '%';
          });
        });
      });
    }

    /* ---- Header count sync ------------------------------------------ */
    function syncHeaderCount(count) {
      var n = parseInt(count, 10) || 0;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        if (el.classList.contains('js-cart-drawer')) return; // skip drawer root
        el.textContent = n;
        el.hidden = n < 1;
      });
    }

    /* ---- Replace drawer contents from fetched section HTML ---------- */
    function updateDrawerFromSectionHtml(html) {
      if (!html) return false;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newDrawer = doc.querySelector('.js-cart-drawer');
      if (!newDrawer || !drawer.parentNode) return false;

      var prevWidth = getShippingBarWidth();
      var count = newDrawer.getAttribute('data-cart-count');
      drawer.innerHTML = newDrawer.innerHTML;
      if (count != null) {
        drawer.setAttribute('data-cart-count', count);
        syncHeaderCount(count);
      }
      animateShippingBars(prevWidth);
      return true;
    }

    /* ---- Fetch fresh drawer via Section Rendering API --------------- */
    var refreshPending = false;
    window.refreshCartDrawer = function () {
      if (refreshPending) return Promise.resolve();
      refreshPending = true;
      var apiId = drawer.dataset.sectionApiId || 'cart-drawer';
      var url = root + '?sections=' + apiId + '&_=' + Date.now();
      return fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data && data.sections && (data.sections[apiId] || data.sections['cart-drawer']);
          updateDrawerFromSectionHtml(html);
        })
        .catch(function () {})
        .finally(function () { refreshPending = false; });
    };

    /* ---- Delegated clicks inside the drawer ------------------------- */
    drawer.addEventListener('click', function (e) {
      /* Close */
      var closeEl = e.target.closest('.js-cart-close');
      if (closeEl) {
        /* Links carrying this class (the empty-state "Shop now") must still
           navigate — only swallow the event for controls that exist purely to
           close, or the click does nothing but shut the drawer. */
        var href = closeEl.tagName === 'A' ? closeEl.getAttribute('href') : null;
        if (!href || href.charAt(0) === '#') e.preventDefault();
        closeDrawer();
        return;
      }

      /* Quantity change */
      var qtyBtn = e.target.closest('.js-cart-qty-change');
      if (qtyBtn) {
        e.preventDefault();
        if (cartUpdating) return;
        var wrap = qtyBtn.closest('.cart-drawer_item');
        var numEl = wrap && wrap.querySelector('.js-cart-qty-num');
        if (!numEl) return;

        var line = parseInt(qtyBtn.dataset.line, 10);
        var change = parseInt(qtyBtn.dataset.change, 10);
        var qty = (parseInt(numEl.textContent, 10) || 1) + change;
        if (qty < 1) qty = 1; // minus clamps at 1; use the trash button to remove

        /* Never optimistically bump past the stock the line was rendered with.
           The plus button is already disabled at the ceiling, but this also
           covers a rapid double-click landing before the drawer re-renders.
           A max of 0 means untracked stock or overselling allowed. */
        var qtyWrap = qtyBtn.closest('.cart-drawer_qty');
        var qtyMax = qtyWrap ? parseInt(qtyWrap.dataset.qtyMax, 10) : 0;
        if (qtyMax > 0 && qty > qtyMax) return;

        numEl.textContent = qty; // optimistic
        changeLine(line, qty);
        return;
      }

      /* Remove */
      var removeBtn = e.target.closest('.js-cart-remove');
      if (removeBtn) {
        e.preventDefault();
        if (cartUpdating) return;
        var rline = parseInt(removeBtn.dataset.line, 10);
        if (isNaN(rline)) return;
        var row = removeBtn.closest('.cart-drawer_item');
        removeBtn.disabled = true;
        if (row) row.style.opacity = '0.5';
        changeLine(rline, 0);
      }
    });

    function changeLine(line, quantity) {
      cartUpdating = true;
      var apiId = drawer.dataset.sectionApiId || 'cart-drawer';
      fetch(cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ line: line, quantity: quantity, sections: apiId })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data.sections && (data.sections[apiId] || data.sections['cart-drawer']);
          if (!updateDrawerFromSectionHtml(html)) return window.refreshCartDrawer();
        })
        .catch(function () { window.refreshCartDrawer(); })
        .finally(function () { cartUpdating = false; });
    }

    /* ---- Upsell add-to-cart (inside drawer) ------------------------- */
    drawer.addEventListener('submit', function (e) {
      var form = e.target.closest('.js-cart-upsell-form');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('.cart-drawer_extras-add');
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }

      var body = new FormData(form);
      body.append('sections', drawer.dataset.sectionApiId || 'cart-drawer');
      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) return; // error (e.g. sold out)
          var html = data.sections && (data.sections['cart-drawer'] || data.sections[drawer.dataset.sectionApiId]);
          if (!updateDrawerFromSectionHtml(html)) return window.refreshCartDrawer();
        })
        .catch(function () { window.refreshCartDrawer(); })
        .finally(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
        });
    });

    /* ---- Public API: open drawer after add-to-cart from anywhere ---- */
    window.openCartDrawer = openDrawer;
    window.closeCartDrawer = closeDrawer;
    window.animateCartDrawerShippingBars = animateShippingBars;
    /* Consume a `cart-drawer` section string from an add/change response. */
    window.renderCartDrawerHTML = updateDrawerFromSectionHtml;
    window.refreshAndOpenCartDrawer = function () {
      return window.refreshCartDrawer().then(openDrawer);
    };

    /* Auto-open when any add publishes Dawn's cartUpdate pub/sub. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
        if (payload && payload.source === 'cart-drawer') return; // avoid feedback loop
        window.refreshCartDrawer().then(openDrawer);
      });
    }

    /* Open on arrival from the /cart redirect (templates/cart.liquid),
       then strip the flag so a refresh or back-nav doesn't re-open it. */
    if (window.location.search.indexOf('cart=open') !== -1) {
      var params = new URLSearchParams(window.location.search);
      params.delete('cart');
      var query = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
      openDrawer();
    }

    /* Initial shipping bar animation */
    animateShippingBars();
  });
})();
